module.exports = __webpack_public_path__ + "static/home-search-form-back-3-a2737a9bfc6a0565a938fe098d6d8738.png";